export default __webpack_public_path__ + "static/media/Plus-Green.395f474c.svg";